import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/inventory-home-sale.png")